import { render, staticRenderFns } from "./balanceView.vue?vue&type=template&id=3c86cf8c&"
import script from "./balanceView.vue?vue&type=script&lang=js&"
export * from "./balanceView.vue?vue&type=script&lang=js&"
import style0 from "./balanceView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports